import { mapActions, mapGetters } from 'vuex';

const editTitle = {
    computed: {
        ...mapGetters(['getGalleryItem', 'getGalleryMediaSetItem']),
    },
    methods: {
        ...mapActions(['updateSet', 'updateGalleryItem']),
        doEditTitle(item, title) {
            if (item.isMediaSet) {
                const galleryItem = this.getGalleryMediaSetItem(item.id);

                this.updateSet({
                    id: item.id,
                    data: { title },
                }).then((response) => {
                    if (galleryItem) {
                        galleryItem.title = response.title;
                    }

                    item.title = response.title;
                    this.showTitleSuccess();
                });
            } else {
                const galleryItem = this.getGalleryItem(item.id);

                this.updateGalleryItem({
                    id: item.id,
                    data: { title },
                }).then((response) => {
                    if (galleryItem) {
                        galleryItem.title = response.title;
                    }

                    item.title = response.title;
                    this.showTitleSuccess();
                });
            }
        },
        showTitleSuccess() {
            ca.notify({
                icon: 'edit',
                type: 'success',
                message: 'Title successfully updated.',
                timeout: ca.config('toast.timeout'),
            });
        },
    },
};

export default editTitle;
